import React, { useEffect, useState, useRef } from "react";
import MenuHeader from "./MenuHeader";
import Modal from "react-modal";
import { exportClientBookingsUrl, exportDirectHotelBookingsUrl, exportDirectHotelAdminBookingsUrl } from "../utils/utils";
import Swal from "sweetalert2";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Switch from "@mui/material/Switch";
import cantons from "../shared/data/cantons.json";
import { useNotifications } from '../context/NotificationProvider';
import HotelService from "../services/hotel.service";
import UserService from "../services/user.service";
import ProductService from "../services/product.service";
import BookingService from "../services/booking.service";
import AddressService from "../services/address.service";
import { addressFormat } from '../shared/utils/string';
import { Map } from "./google_map";
import axios from "../api/axios";
import Select from 'react-select';
import useApi from "../hooks/useApi";
import imageFile from "../assets/images/upload-file.svg";
import Autocomplete from 'react-google-autocomplete';
import { useLoadScript } from '@react-google-maps/api';
import { styled } from "@mui/material/styles";
import { Menu, MenuList, MenuItem, IconButton, ListItemText, ListItemIcon, Divider, TextField, Button } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import EditIcon from '@mui/icons-material/Edit';
import { useTranslatableData } from '../hooks/useTranslatable';
import FicheHotelService from "../services/fiche_hotel.service";
import { useTranslation } from 'react-i18next';
import { PhoneInput } from 'react-international-phone';
import GeneralSettingService from '../services/general_setting.service';
import DomainService from "../services/domain.service";
import CategoryService from "../services/category.service";
import Papa from 'papaparse';




export const API_BASE_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflow: "hidden auto",
    scrollbarWidth: "none",
    height: "650px",
    maxWidth: '46rem'
  },
};

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#8fa9b9",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: "rgba(0,0,0,.25)",
    boxSizing: "border-box",
  },
}));

const Hotels = () => {
  const { t, i18n } = useTranslation('hotel');
  Modal.setAppElement("#root");
  const libraries = ['places'];
  const [domains, setDomains] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);

  // Use translated data for display
  const translatedDomains = useTranslatableData(domains);
  const translatedCategories = useTranslatableData(categories);
  const translatedSubCategories = useTranslatableData(subCategories);
  const [dateRange, setDateRange] = useState({
    start_date: "",
    end_date: "",
  });

  const buildDateRangeQuery = (dateRange) => {
    const { start_date, end_date } = dateRange;
  
    if (start_date && end_date) {
      return `&start_before=between:${start_date},${end_date}T23:59:59`;
    }

    return "";
  };
  
  const handleExportClientBookings = async (hotelId, hotelManagerId) => {
    const adminsRes = await UserService.indexByRole({}, 'ROLE_ADMIN', api)
    const adminsResIds =  adminsRes.map(a => a.id).join(',')
    const dateQuery = buildDateRangeQuery(dateRange);
    try {
      const url = exportClientBookingsUrl(hotelId, hotelManagerId, adminsResIds, dateQuery);

      // Fetch the file as blob
      const response = await api.get(url, {
        responseType: 'blob',
      });

      const csvText = await response.data.text();
      
      const parsed = Papa.parse(csvText, { header: false });
      const rows = parsed.data;
      
      for (let i = 0; i < rows.length; i++) {
        const cols = rows[i];
        if (cols && cols.length > 1 && cols[1]) {
          cols[1] = cols[1].replace(/[\n\r]/g, ' ').trim();
        }
      }
      
      const cleanedCsv = Papa.unparse(rows);

      const blob = new Blob([cleanedCsv], {
        type: "text/csv;charset=utf-8;",
      });

      // Force a download
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "client_hotel_bookings.csv";
      document.body.appendChild(link);
      link.click();
      link.remove();

    } catch (error) {
      console.error('Error exporting client bookings:', error);
    }
  };

  const [ficheFormData, setFicheFormData] = useState({
    id: '',
    hotel_id: '',
    tenue_vestimentaire: '',
    parking: '',
    ou_se_diriger: '',
    comment_et_ou_sinstaller: '',
    materiel_a_prendre: '',
    materiel_sur_place: '',
    prestations_que_lon_peut_fournir: '',
    infos_complementaires: '',
  });

  const handleExportMergedDirectHotelBookings = async (hotelId, hotelManagerId) => {
    try {
      const adminsRes = await UserService.indexByRole({}, 'ROLE_ADMIN', api);
      const adminsResIds = adminsRes.map(a => a.id).join(',');
      const dateQuery = buildDateRangeQuery(dateRange);

      const adminUrl = exportDirectHotelAdminBookingsUrl(hotelId, adminsResIds, dateQuery);
      
      const managerUrl = exportDirectHotelBookingsUrl(hotelId, hotelManagerId, dateQuery);
  
      const [adminResponse, managerResponse] = await Promise.all([
        api.get(adminUrl, { responseType: 'blob' }),
        api.get(managerUrl, { responseType: 'blob' })
      ]);
  
      const [adminText, managerText] = await Promise.all([
        adminResponse.data.text(),
        managerResponse.data.text()
      ]);
  
      const vtaResponse = await GeneralSettingService.index('setting=in:VTA', api);
      const vta = parseFloat(vtaResponse[0]?.value) || 0;
  
      const processCSV = (csvText) => {
        const parsed = Papa.parse(csvText, { header: false });
        const rows = parsed.data;
        
        if (rows.length > 0) {
          if (!rows[0].includes('Transfer Price')) {
            rows[0].push('Transfer Price');
          }
      
          for (let i = 1; i < rows.length; i++) {
            const cols = rows[i];
            if (!cols || cols.length === 0) continue;

            if (cols[1]) {
              cols[1] = cols[1].replace(/[\n\r]/g, ' ').trim();
            }
      
            const priceStr = cols[19]?.trim().replace(/"/g, '');

            let totalPriceWithVat = 0;
            
            if (priceStr) {
              const priceParts = priceStr
                .split(',')
                .map(p => parseFloat(p.trim()))
                .filter(p => !isNaN(p));
            
              if (priceParts.length > 0) {
                totalPriceWithVat = priceParts.reduce((sum, val) => sum + val, 0);
              }
            }
            
            let priceExclVat = '';
            if (totalPriceWithVat > 0 && vta > 0) {
              priceExclVat = (totalPriceWithVat / (1 + vta / 100)).toFixed(2);
            }
            
            cols.push(priceExclVat);
            
          }
        }
      
        return Papa.unparse(rows);
      };
  
      const adminRows = processCSV(adminText);
      const managerRows = processCSV(managerText);
  
      const adminLines = adminRows.split('\n');
      const managerLines = managerRows.split('\n');

      let mergedRows = [];
      if (adminLines.length > 0) {
        let headers = [];
        if (adminLines.length > 0 && adminLines[0].trim() !== '' && !adminLines[0].startsWith(',')) {
          headers = adminLines[0].split(',');
        } else if (managerLines.length > 0) {
          headers = managerLines[0].split(',');
        }
        mergedRows.push(headers.join(','));
        mergedRows = mergedRows.concat(adminLines.slice(1));
        mergedRows = mergedRows.concat(managerLines.slice(1));
      } else if (managerLines.length > 0) {
        mergedRows = managerLines;
      }

      const finalRows = mergedRows.filter(row => row.trim() !== '');
      const updatedCsv = finalRows.join('\n');

      const blob = new Blob([updatedCsv], {
        type: 'text/csv;charset=utf-8;',
      });

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'direct_hotel_bookings.csv';
      document.body.appendChild(link);
      link.click();
      link.remove();
  
    } catch (error) {
      console.error('Error exporting merged direct hotel bookings:', error);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error.response?.data?.message || 'An error occurred during export.',
      });
    }
  };

  const handleExportDirectHotelBookings = async (hotelId, hotelManagerId) => {
    try {
      const url = exportDirectHotelBookingsUrl(hotelId, hotelManagerId);

      // Fetch the file as blob
      const response = await api.get(url, {
        responseType: 'blob',
      });

      const text = await response.data.text();
      const vtaResponse = await GeneralSettingService.index('setting=in:VTA', api);
      const vta = parseFloat(vtaResponse[0]?.value) || 0;

      let csvText = text;
      const rows = csvText.split('\n');

      if (rows.length > 0) {
        rows[0] = rows[0].trim() + ',Transfer Price';

        for (let i = 1; i < rows.length; i++) {
          const row = rows[i].trim();

          if (row !== '') {
            const cols = row.split(',');
            const priceStr = cols[14]?.trim().replace(/"/g, '');
            const priceWithVat = parseFloat(priceStr);

            let priceExclVat = '';
            if (!isNaN(priceWithVat) && vta > 0) {
              priceExclVat = (priceWithVat / (1 + vta / 100)).toFixed(2);
            }

            rows[i] = row + `,${priceExclVat}`;
          }
        }

        const updatedCsv = rows.join('\n');

        const blob = new Blob([updatedCsv], {
          type: 'text/csv;charset=utf-8;',
        });

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'direct_hotel_bookings.csv';
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      console.error('Error exporting direct hotel bookings:', error);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error.response?.data?.message || 'An error occurred during export.',
      });
    }
  };

  const notify = useNotifications();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [hotels, setHotels] = useState([]);
  const [modalIsOpenManage, setIsOpenManage] = React.useState(false);
  const [modalIsOpenAddressManage, setIsOpenAddressManage] = React.useState(false);
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [allBookings, setAllBookings] = useState([]);
  const [directBookings, setDirectBookings] = useState([]);
  const [allBookingsTotal, setAllBookingsTotal] = useState(0);
  const [directBookingsTotal, setDirectBookingsTotal] = useState(0);
  const [allBookingsPage, setAllBookingsPage] = useState(1);
  const [directBookingsPage, setDirectBookingsPage] = useState(1);
  const [bookingsPerPage, setBookingsPerPage] = useState(10);
  const [isAccountModalOpen, setIsAccountModalOpen] = useState(false);
  const [allBookingsLimit, setAllBookingsLimit] = useState(10);
  const [directBookingsLimit, setDirectBookingsLimit] = useState(10);
  const loadMoreAllBookings = () => {
    setAllBookingsPage((prevPage) => prevPage + 1);
  };
  const loadMoreDirectBookings = () => {
    setDirectBookingsPage((prevPage) => prevPage + 1);
  };
  const limitedAllBookings = allBookings;
  const limitedDirectBookings = directBookings;
  const translatedBookings = useTranslatableData(limitedAllBookings);
  const translatedDirectBookings = useTranslatableData(limitedDirectBookings);


  const [accountFormData, setAccountFormData] = useState({
    email: '',
    firstname: '',
    lastname: '',
    phone: '',
    role: '',
    hotel_id: ''
  });

  const [formData, setFormData] = useState({
    name: "",
    address: "",
    phone: "",
    email: "",
    contact_first_name: "",
    contact_last_name: "",
    zip_code: "",
    state: "",
    state_code: "",
    street: "",
    street_number: "",
    city: "",
    country: "Switzerland",
    country_code: "CH",
    flypro_instructions: "",
    duo_capability: false,
    latitude: null,
    longitude: null,
    is_only_internal: false
  });

  const api = useApi();
  const hotelBookingsAbortControllerRef = useRef(null);
  const directBookingsAbortControllerRef = useRef(null);
  const [bookingsLoading, setBookingsLoading] = useState(false);

  const [filterData, setFilterData] = useState({
    search: "",
    search_by: "name",
    operator: "contains",
  });

  const [allHotels, setAllHotels] = useState([]);
  const [isAddressUpdate, setIsAddressUpdate] = useState(false);
  const [coordinates, setCoordinate] = useState({
    lat: 46.356,
    lng: 6.5641
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(100);
  const [total, setTotal] = useState(0);
  const [lastPage, setLastPage] = useState(1);
  const [filters, setFilters] = useState({
    with: 'address,addresses,account,media,ficheHotel,product',
    page: currentPage,
    per_page: perPage
  });
  const [autoCompleteValue, setAutoCompleteValue] = useState("");

  const [sortDirection, setSortDirection] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [detailsModalIsOpenFiche, setDetailsModalIsOpenFiche] = useState(false);

  const customSelectStyles = {
    control: (styles) => ({
      ...styles,
      width: '100%',
      height: '60px',
      padding: '0 15px',
      fontSize: '14px',
      lineHeight: '60px',
      color: '#393D44',
      border: '0',
      borderRadius: '20px',
      background: '#ffffff',
    }),
    indicatorSeparator: (base) => ({
      ...base,
      display: 'none',
    }),
    // placeholder: (base) => ({
    //   ...base,
    //   marginTop: '-10px',
    // }),
    // dropdownIndicator: (base) => ({
    //   ...base,
    //   marginTop: '-10px',
    // }),
  };

  const [selectedState, setSelectedState] = useState(null);
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);
  const [hoveredRow, setHoveredRow] = useState(null);
  const timeoutRef = useRef(null);
  const [selectedAddresses, setSelectedAddresses] = useState([]);
  const [availableAddresses, setAvailableAddresses] = useState([]);
  const [modalType, setModalType] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [addresses, setAddresses] = useState([]);
  const [showMap, setShowMap] = useState(false);
  const [newAddress, setNewAddress] = useState({
    street: '',
    city: '',
    zip_code: '',
    street_number: '',
    state: '',
    state_code: '',
    country: 'Switzerland',
    country_code: 'CH',
    lat: null,
    lng: null,
    hotel_id: ""
  });

  const [isZipCodeVisible, setIsZipCodeVisible] = useState(false);
  const [isProductEditModalOpen, setIsProductEditModalOpen] = useState(false);
  const [selectedHotelId, setSelectedHotelId] = useState(null);
  const [hotelProducts, setHotelProducts] = useState([]);
  const [isProductListVisible, setIsProductListVisible] = useState(true);
  const [productFormData, setProductFormData] = useState({
    id: null,
    name: "",
    description: "",
    duration: "",
    price: "",
    is_active: 1,
    hotel_id: "",
    parent_category_id: "",
    category_id: "",
    domain_id: "",
    subcategory_id: "",
  });
  const translatedHotelProducts = useTranslatableData(hotelProducts);

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: ['places'],
  });

  /* ========================================== */

  const handleStateChange = (data) => {
    setIsAddressUpdate(true);
    let selected = cantons.cantons.find(
      (canton) => canton.name === data?.value
    );
    document.querySelector('input[name="zip_code"]').setAttribute('placeholder', selected?.zip_code_range || '');
    setFormData({
      ...formData, zip_code: ''
    });
    setFormData({
      ...formData,
      state: data?.value,
    });
    setSelectedState(data);
  };

  const handleChangeFiche = async (e) => {

    setFicheFormData({
      ...ficheFormData,
      [e.target.name]: e.target.value,
    });

  };

  const handleSubmitFiche = async (e) => {
    e.preventDefault();

    try {
      const response = await (ficheFormData.id ? FicheHotelService.update(ficheFormData.id, { ...ficheFormData, hotel_id: selectedHotel.id }, api) : FicheHotelService.store({ ...ficheFormData, hotel_id: selectedHotel.id }, api));
      if (response.data) {
        closeFichesModal();
        fetchHotels();
      }
    } catch (e) {
      // errors handled in interceptor
    }
  };

  // Fetch Hotels
  const fetchHotels = async () => {
    try {
      const response = await HotelService.index(filters, api);
      console.log("API Response:", response);
      setAllHotels(response.data);
      setTotal(response.total);
      setLastPage(response.last_page);
      if (response.last_page < currentPage) {
        setFilters({ ...filters, page: response.last_page })
        setCurrentPage(response.last_page);
      }
      setHotels(response.data);
    } catch (error) {

    }
  };

  const fetchBookings = async (id) => {
    try {
      const response = await BookingService.index({hotel_id: id, with: 'creator,product,client' }, api);
      console.log('Fetched bookings:', response);
      setAllBookings(response.account.bookings);
      setDirectBookings(response.directBookings);
      setHotels(response);
    } catch (error) {

    }
  };

  const fetchHotelBookings = async (id, page = 1) => {
    try {
      // Cancel previous request
      if (hotelBookingsAbortControllerRef.current) {
        hotelBookingsAbortControllerRef.current.abort();
      }
      
      // Create new abort controller for this request
      hotelBookingsAbortControllerRef.current = new AbortController();
      const signal = hotelBookingsAbortControllerRef.current.signal;
      
      setBookingsLoading(true);
      const adminsRes = await UserService.indexByRole({}, 'ROLE_ADMIN', api)
      const adminsResIds =  adminsRes.map(a => a.id).join(',')
      const managerId = selectedHotel.account_id;      
      let params = {
        hotel_id: id,
        created_by: `!eq:${managerId}`,
        client_id: `not_in:${adminsResIds}`,
        with: "creator.roles,product,client,products, products.category",
        sort: "-created_at",
        page: page,
        per_page: bookingsPerPage,
      };
      if (dateRange.start_date && dateRange.end_date) {
        params.start_before = `between:${dateRange.start_date},${dateRange.end_date}T23:59:59`;
      }
      const response = await BookingService.index(
        params,
        api
      );
      // Only update state if this request wasn't aborted
      if (!signal.aborted) {
        // const hotelBooking = (response.data || response).filter((booking) => {
        //   const hasNonHotelManagerRole = booking.creator &&
        //     Array.isArray(booking.creator.roles) &&
        //     booking.creator.roles.some(role => role.name !== "ROLE_HOTEL_MANAGER");

        //   const isClientAdmin = booking.client &&
        //     Array.isArray(booking.client.roles) &&
        //     booking.client.roles.some(role => role.name === "ROLE_ADMIN");

        //   return hasNonHotelManagerRole && !isClientAdmin;
        // });
        
        setAllBookings(response.data || response);
        // Use the total from API response for accurate pagination
        const apiTotal = response.total || response.data?.length || 0;
        setAllBookingsTotal(apiTotal > 0 ? apiTotal : 0);
      }
    } catch (error) {
      // Ignore abort errors
      if (error.name !== 'AbortError') {
        console.error('Error fetching hotel bookings:', error);
      }
    } finally {
      setBookingsLoading(false);
    }
  };

  const fetchHotelDirectBookings = async (id, page = 1) => {
    try {
      // Cancel previous request
      if (directBookingsAbortControllerRef.current) {
        directBookingsAbortControllerRef.current.abort();
      }
      
      // Create new abort controller for this request
      directBookingsAbortControllerRef.current = new AbortController();
      const signal = directBookingsAbortControllerRef.current.signal;
      
      setBookingsLoading(true);
      const adminsRes = await UserService.indexByRole({}, 'ROLE_ADMIN', api)
      const adminsResIds =  adminsRes.map(a => a.id).join(',')
      const managerId = selectedHotel.account_id;
      
      let paramsClient = {
        hotel_id: id,
        client_id: `in:${adminsResIds}`,
        with: "creator.roles,product,client,products, products.category",
        sort: "-created_at",
        page: page,
        per_page: 5,
      };
      let paramsManager = {
        hotel_id: id,
        created_by: managerId,
        with: "creator.roles,product,client,products, products.category",
        sort: "-created_at",
        page: page,
        per_page: 5,
      };
      if (dateRange.start_date && dateRange.end_date) {
        paramsClient.start_before = `between:${dateRange.start_date},${dateRange.end_date}T23:59:59`;
        paramsManager.start_before = `between:${dateRange.start_date},${dateRange.end_date}T23:59:59`;
      }
      const responseClient = await BookingService.index(
        paramsClient,
        api
      );
      const responseManager = await BookingService.index(
        paramsManager,
        api
      );

      const all = [...(responseClient.data || responseClient), ...(responseManager.data || responseManager)];
      
      // Only update state if this request wasn't aborted
      if (!signal.aborted) {
        // const onlyManager = all.filter((booking) => {
        //   const hasNonHotelManagerRole = booking.creator &&
        //     Array.isArray(booking.creator.roles) &&
        //     booking.creator.roles.some(role => role.name === "ROLE_HOTEL_MANAGER");

        //   const isClientAdmin = booking.client &&
        //     Array.isArray(booking.client.roles) &&
        //     booking.client.roles.some(role => role.name === "ROLE_ADMIN");

        //   return hasNonHotelManagerRole || isClientAdmin;
        // });
        setDirectBookings(all);
        // Use the total from API response for accurate pagination
        const apiTotal = responseClient.total + responseManager.total || all.length;
        setDirectBookingsTotal(apiTotal > 0 ? apiTotal : 0);
      }
    } catch (error) {
      // Ignore abort errors
      if (error.name !== 'AbortError') {
        console.error('Error fetching direct bookings:', error);
      }
    } finally {
      setBookingsLoading(false);
    }
  };

  // Cleanup pending requests on component unmount
  useEffect(() => {
    return () => {
      if (hotelBookingsAbortControllerRef.current) {
        hotelBookingsAbortControllerRef.current.abort();
      }
      if (directBookingsAbortControllerRef.current) {
        directBookingsAbortControllerRef.current.abort();
      }
    };
  }, []);

  useEffect(() => {
    fetchHotels();
  }, [currentPage, perPage]);

  useEffect(() => {
    if(selectedHotel){
      fetchHotelBookings(selectedHotel.id, allBookingsPage);
      fetchHotelDirectBookings(selectedHotel.id, directBookingsPage);
    }
  }, [dateRange, allBookingsPage, directBookingsPage, bookingsPerPage]);

  const closeModalManage = () => {
    // Cancel any pending bookings fetch requests
    if (hotelBookingsAbortControllerRef.current) {
      hotelBookingsAbortControllerRef.current.abort();
    }
    if (directBookingsAbortControllerRef.current) {
      directBookingsAbortControllerRef.current.abort();
    }
    setIsOpenManage(false);
    setSelectedHotel(null);
    setDateRange({
      start_date: "",
      end_date: "",
    });
    setAllBookingsPage(1);
    setDirectBookingsPage(1);
    setAllBookings([]);
    setDirectBookings([]);
    setAllBookingsTotal(0);
    setDirectBookingsTotal(0);
  };

  const openModalManage = (hotel) => {
    setSelectedHotel(hotel);
    // fetchBookings(hotel.id);
    fetchHotelBookings(hotel.id);
    fetchHotelDirectBookings(hotel.id);
    setModalType("addresses");
    setIsOpenManage(true);
    setDateRange({
      start_date: "",
      end_date: "",
    });
  };

  const handleSwitchChange = (event) => {
    setFormData((prevData) => ({
      ...prevData,
      duo_capability: event.target.checked ? 1 : 0,
    }));
  };

  const handleSwitchInternalChange = (event) => {
    setFormData((prevData) => ({
      ...prevData,
      is_only_internal: event.target.checked ? 1 : 0,
    }));
  };

  const handleAccountFormChange = (e) => {
    const { name, value } = e.target;
    setAccountFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleAccPhoneChange = (value) => {
    setAccountFormData({
      ...accountFormData,
      phone: value,
    });
  };

  const handleChange = (e) => {
    if (formData.id && e.target.name === 'zip_code' || e.target.name === 'street' || e.target.name === 'street_number' || e.target.name === 'city') {
      setIsAddressUpdate(true);
    }
    if (e.target.name === "file") {
      console.log({ e });
      const file = e.target.files[0];
      if (file) {
        setFileName(file.name);
        setFile(file);
      }
    } else {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    formData.birthdate = formData.birthdate === '' ? null : formData.birthdate;
    formData.role = 'ROLE_CLIENT';
    formData.country = "Switzerland";
    formData.country_code = "CH";

    const formDataToSend = new FormData();

    for (const key in formData) {
      const value = formData[key];
      if (value != null) {
        if (Array.isArray(value) || typeof value === 'object') {
          formDataToSend.append(key, JSON.stringify(value));
        } else if (typeof value === 'boolean') {
          formDataToSend.append(key, Number(value));
        } else {
          formDataToSend.append(key, value);
        }
      }
    }

    if (file) {
      formDataToSend.append("imageFile", file);
    }
    try {
      const response = await (formData.id ? HotelService.updateWithImage(formData.id, formDataToSend, api) : HotelService.store(formDataToSend, api));
      if (response.data) {
        closeModal();
        fetchHotels();
      }
    } catch (e) {
      // errors handled in interceptor
    }
  };

  const handleAccountFormSubmit = async (e) => {
    e.preventDefault();

    if (!accountFormData.email || !accountFormData.firstname || !accountFormData.lastname) {
      notify.warn("Please fill out all required fields!");
      return;
    }

    try {
      const data = {
        ...accountFormData,
        role: 'ROLE_HOTEL_MANAGER',
        hotel_id: selectedHotel.id
      };

      if (accountFormData.id) {
        await UserService.update(accountFormData.id, data, api);
        notify.success("Account updated successfully!");
      } else {

        await UserService.store(data, api);
        notify.success("Account created successfully!");
      }

      setIsAccountModalOpen(false);
      setAccountFormData({
        email: '',
        firstname: '',
        lastname: '',
        phone: '',
        role: '',
        hotel_id: ''
      });

      fetchHotels();
    } catch (error) {
      notify.error(error.response?.data?.message || 'An error occurred');
    }
  };

  const resetFormData = () => {
    setFormData({
      id: null,
      name: "",
      address: "",
      phone: "",
      email: "",
      contact_first_name: "",
      contact_last_name: "",
      zip_code: "",
      state: "",
      state_code: "",
      street: "",
      street_number: "",
      city: "",
      country: "Switzerland",
      country_code: "CH",
      flypro_instructions: "",
      duo_capability: false,
      latitude: null,
      longitude: null,
      is_only_internal: false
    });
    setCoordinate({ lat: 46.356, lng: 6.5641 });
    setSelectedState(null);
  };
  const openModal = (hotel) => {
    if (hotel && hotel.id) {
      setFormData({
        ...formData,
        ...hotel,
        address: hotel.address?.id,
        zip_code: hotel.address?.zip_code,
        state: hotel.address?.state,
        state_code: hotel.address?.state_code,
        street: hotel.address?.street,
        street_number: hotel.address?.street_number,
        city: hotel.address?.city,
        latitude: hotel.address?.latitude,
        longitude: hotel.address?.longitude,
      });

      if (hotel.address?.state) {
        setSelectedState({
          value: hotel.address?.state,
          label: hotel.address?.state,
        });
      }

      setCoordinate({
        lat: hotel.address?.latitude,
        lng: hotel.address?.longitude,
      });

      // Fixed address string
      const addressString =
        `${hotel.address?.street_number ?? ""} ${hotel.address?.street ?? ""}, ` +
        `${hotel.address?.city ?? ""}, ${hotel.address?.state ?? ""} ` +
        `${hotel.address?.zip_code ?? ""}`.trim();

      setAutoCompleteValue(addressString);
      setFile(null);
      setFileName("");
    } else {
      resetFormData();
      setAutoCompleteValue("");
    }
    setIsOpen(true);
    setShowMap(false);
  };

  const fetchCoordinates = async () => {
    const { street_number, street, city, state, zip_code } = formData;
    const address = `${street_number} ${street}, ${city}, ${state} ${zip_code}`;

    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json`,
        {
          params: {
            address,
            key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
          },
        }
      );

      if (response.data.results.length > 0) {
        const location = response.data.results[0].geometry.location;
        setFormData({
          ...formData,
          latitude: location.lat,
          longitude: location.lng,
        });
        setCoordinate({
          lat: location.lat,
          lng: location.lng
        });
      } else {
        console.error('No results found for the given address.');
      }
    } catch (error) {
      console.error('Error fetching coordinates:', error);
    }
  };

  const handleEditAccount = (account) => {
    console.log("toto", account)
    setAccountFormData({
      id: account.id,
      email: account.email,
      firstname: account.firstname,
      lastname: account.lastname,
      phone: account.phone,
      role: 'ROLE_HOTEL_MANAGER',
      hotel_id: selectedHotel.id
    });
    setIsAccountModalOpen(true);
  };

  const handleCoordinateChange = (coordinates) => {
    setFormData({
      ...formData,
      longitude: coordinates[0]?.lng,
      latitude: coordinates[0]?.lat,
    })
    setCoordinate({
      lat: coordinates[0]?.lng,
      lng: coordinates[0]?.lat,
    })
  }

  const openFicheModal = (hotel) => {
    setSelectedHotel(hotel);
    setFicheFormData({
      id: hotel.fiche_hotel[0]?.id,
      hotel_id: hotel.fiche_hotel[0]?.hotel_id,
      tenue_vestimentaire: hotel.fiche_hotel[0]?.tenue_vestimentaire,
      parking: hotel.fiche_hotel[0]?.parking,
      ou_se_diriger: hotel.fiche_hotel[0]?.ou_se_diriger,
      comment_et_ou_sinstaller: hotel.fiche_hotel[0]?.comment_et_ou_sinstaller,
      materiel_a_prendre: hotel.fiche_hotel[0]?.materiel_a_prendre,
      materiel_sur_place: hotel.fiche_hotel[0]?.materiel_sur_place,
      prestations_que_lon_peut_fournir: hotel.fiche_hotel[0]?.prestations_que_lon_peut_fournir,
      infos_complementaires: hotel.fiche_hotel[0]?.infos_complementaires,
    });
    setDetailsModalIsOpenFiche(true);
  };

  const closeFichesModal = () => {
    setSelectedHotel(null);
    setFicheFormData({
      id: '',
      hotel_id: '',
      tenue_vestimentaire: '',
      parking: '',
      ou_se_diriger: '',
      comment_et_ou_sinstaller: '',
      materiel_a_prendre: '',
      materiel_sur_place: '',
      prestations_que_lon_peut_fournir: '',
      infos_complementaires: '',
    });
    setDetailsModalIsOpenFiche(false);
  };



  const closeModal = () => {
    setIsOpen(false);
  };

  // Open account modal
  const handleCreateAccountClick = () => {
    setIsAccountModalOpen(true);
  };

  // Close account modal
  const handleModalClose = () => {
    setIsAccountModalOpen(false);
    setAccountFormData({
      email: '',
      firstname: '',
      lastname: '',
      phone: '',
      role: '',
      hotel_id: ''
    });
  };

  const handleFilterSubmit = async (e) => {
    e.preventDefault();

    if (filterData.search !== '' && filterData.search_by !== 'city') {
      filters[filterData.search_by] = `${filterData.operator}:${filterData.search}`;
    } else if (filterData.search_by === 'city') {
      const addresses = await AddressService.index({ columns: 'id,city', city: `${filterData.operator}:${filterData.search}` }, api)
      if (addresses.length) {
        const ids = addresses.map((address) => address.id).join(',');
        console.log({ ids })
        filters['address_id'] = `in:${ids}`;
      } else {
        filters['address_id'] = `-1`;
      }
    }

    await fetchHotels();
  };

  const handleFilterChange = async (e) => {
    const target = e.target;

    if (target.name === 'search_by') {
      const search = document.querySelector('input[name="search"]');

      search.setAttribute('placeholder', `${t('hotel:filters.search.searchBy')} ${target.options[target.selectedIndex].innerHTML}`);
      filterData.search = '';
      delete filters.name;
      delete filters.address_id;
      delete filters.contact_first_name;
      delete filters.contact_last_name;


      setFilterData({
        ...filterData,
        [target.name]: target.value
      });
      await fetchHotels();
    } else if (target.name === 'search' && target.value === '') {
      setFilterData({
        ...filterData,
        [target.name]: target.value
      });
      delete filters.name;
      delete filters.address_id;
      delete filters.contact_first_name;
      delete filters.contact_last_name;
      await fetchHotels();
    }
    setFilterData({
      ...filterData,
      [target.name]: target.value
    });
  }

  const handleEditMouseEnter = (index) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setHoveredRow(index);
  };

  const handleEditMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setHoveredRow(null);
    }, 250);
  };

  const handleNextPage = () => {
    setFilters({ ...filters, page: currentPage + 1 });
    setCurrentPage(currentPage + 1);
  }

  const handlePrevPage = () => {
    setFilters({ ...filters, page: currentPage - 1 });
    setCurrentPage(currentPage - 1);
  }

  const handleLastPage = () => {
    setFilters({ ...filters, page: lastPage });
    setCurrentPage(lastPage);
  }

  const handleFirstPage = () => {
    setFilters({ ...filters, page: 1 });
    setCurrentPage(1);
  }

  const handlePerPageChange = (e) => {
    setFilters({ ...filters, per_page: e.target.value, page: 1 });
    setPerPage(e.target.value);
    setCurrentPage(1);
  }

  const handleSelectedSort = async (event) => {
    const selected = document.querySelector('.sort-header.active');
    let direction = true;
    if (selected?.id !== event.target.id) {
      selected?.classList.remove('active');
      event.target.classList.add('active');
      setSortDirection(true);
    } else {
      setSortDirection(!sortDirection);
      direction = !sortDirection;
    }

    const sortField = event.target.id === 'name' ? `${direction ? '' : '-'}name` : `${direction ? '' : '-'}${event.target.id}`;
    setFilters({ ...filters, sort: sortField });
    filters.sort = sortField;

    await fetchHotels(); // Refresh data with new sort order
  };

  const handleDelete = async (id) => {
    try {
      const response = await HotelService.delete(id, api);
      fetchHotels();
    } catch (error) {

    }
  };

  const handleRemoveAddress = async (addressToRemove) => {
    try {
      await AddressService.delete(addressToRemove.id, api);

      // Update the selected and available addresses state
      const updatedAddresses = selectedAddresses.filter(
        (address) => address.id !== addressToRemove.id
      );

      const updatedAvailableAddresses = [...availableAddresses, addressToRemove];

      setSelectedAddresses(updatedAddresses);
      setAvailableAddresses(updatedAvailableAddresses);

      const updatedSelectedRow = {
        ...selectedRow,
        addresses: selectedRow.addresses.filter(
          (address) => address.id !== addressToRemove.id
        ),
      };

      setSelectedRow(updatedSelectedRow);
    } catch (error) {

    }
  };

  function afterOpenManageModal() {
  }

  const openManageModal = async (type, row) => {
    setModalType(type);
    setSelectedRow(row);

    if (type === "addresses") {
      console.log('selectedRow: ', selectedRow)
      const hotelAddresses = addresses.filter((address) =>
        row.addresses.some((userAddress) => userAddress.id === address.id)
      );
      const availableAddresses = addresses.filter(
        (address) => !hotelAddresses.some((userAddress) => userAddress.id === address.id)
      );
      setSelectedAddresses(hotelAddresses);
      setAvailableAddresses(availableAddresses);
    }

    setIsOpenAddressManage(true);
  };

  const closeModalAddressManage = () => {
    setIsOpenAddressManage(false);
  };

  const handleAddAddress = async (e) => {
    e.preventDefault();

    const hotelId = selectedRow?.id;

    try {
      const addressData = {
        ...newAddress,
        hotel_id: hotelId,
      };

      console.log('addressData: ', addressData);

      const response = await AddressService.store(addressData, api);

      // Update the selected row with the new address
      setSelectedRow(prev => ({
        ...prev,
        addresses: [...prev.addresses, response.data],
      }));

      setNewAddress({
        zip_code: "",
        state: "",
        state_code: "",
        street: "",
        street_number: "",
        city: "",
        country: "Switzerland",
        country_code: "CH",
      });

      setIsZipCodeVisible(false);
    } catch (error) {

    }
  };

  const handlePlaceSelect = (place) => {
    const zipCode = place.address_components.find((component) =>
      component.types.includes("postal_code")
    )?.long_name;
    const addressComponents = place.address_components;
    const updatedAddress = {
      street: '',
      city: '',
      zip_code: '',
      street_number: '',
      state: '',
      state_code: '',
      country: 'Switzerland',
      country_code: 'CH',
      latitude: place.geometry.location.lat(),
      longitude: place.geometry.location.lng(),
    };

    if (zipCode) {
      setFormData((prev) => ({ ...prev, zip_code: zipCode }));
      setIsZipCodeVisible(false);
    } else {
      setIsZipCodeVisible(true);
    }

    addressComponents.forEach(component => {
      const type = component.types[0];
      switch (type) {
        case 'street_number':
          updatedAddress.street_number = component.long_name;
          break;
        case 'route':
          updatedAddress.street = component.long_name;
          break;
        case 'locality':
          updatedAddress.city = component.long_name;
          break;
        case 'postal_code':
          updatedAddress.zip_code = component.long_name;
          break;
        case 'administrative_area_level_1':
          updatedAddress.state = component.long_name;
          updatedAddress.state_code = component.short_name;
          break;
      }
    });

    setFormData((prev) => ({
      ...prev,
      ...updatedAddress,
    }));
    setCoordinate({ lat: updatedAddress.latitude, lng: updatedAddress.longitude });
    setShowMap(false);
    setNewAddress(updatedAddress);
    setIsZipCodeVisible(!updatedAddress.zip_code);
  };

  const handleFormSwitchChange = () => {
    setProductFormData((prevData) => ({
      ...prevData,
      is_active: prevData.is_active ? 0 : 1,
    }));
  };

  const handleProductChange = async (e) => {
    const { name, value, files } = e.target;

    if (name === "domain_id") {
      const topLevelCategories = await CategoryService.index({ domain_id: value, parent_id: null, status: 'ACTIVE' }, api);
      setCategories(topLevelCategories);
    }
    if (name === "category_id") {
      try {
        const response = await CategoryService.index(
          { parent_id: value, status: 'ACTIVE' },
          api
        );
        console.log("tt", response);
        setSubCategories(response);
      } catch (error) {
        console.error(error);
      }
    }

    if (name === "file") {
      const fileSelected = files[0];
      if (fileSelected) {
        setFileName(fileSelected.name);
        setFile(fileSelected);
      }
      return;
    }

    setProductFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

  };

  const resetProductForm = () => {
    setProductFormData({
      id: null,
      name: "",
      description: "",
      duration: "",
      price: "",
      is_active: 1,
      hotel_id: selectedHotelId,
      parent_category_id: "",
      category_id: "",
      domain_id: "",
      subcategory_id: "",

    });
    setFile(null);
    setFileName("");
  };

  const handleProductSubmit = async (e) => {
    e.preventDefault();

    const updatedFormData = {
      ...productFormData,
      parent_category_id: productFormData.category_id,
      category_id: productFormData.subcategory_id,
      subcategory_id: "",
    };

    setProductFormData(updatedFormData);

    const formDataToSend = new FormData();

    for (const key in updatedFormData) {
      let value = updatedFormData[key];

      if (key === "is_active") {
        value = value ? 1 : 0;
      }

      if (value !== null && value !== undefined && value !== "") {
        if (Array.isArray(value) || typeof value === "object") {
          formDataToSend.append(key, JSON.stringify(value));
        } else {
          formDataToSend.append(key, value);
        }
      }
    }

    if (file) {
      formDataToSend.append("imageFile", file);
    }

    try {
      if (updatedFormData.id) {
        if (file) {
          await ProductService.updateWithImage(updatedFormData.id, formDataToSend, api);
        } else {
          const { id, ...updateData } = updatedFormData;
          await ProductService.update(id, updateData, api);
        }
      } else {
        await ProductService.store(formDataToSend, api);
      }

      fetchHotelProducts(selectedHotelId);
      resetProductForm();
      setIsProductListVisible(true);
    } catch (error) {
      console.error("Submission error:", error);
    }
  };

  const fetchHotelProducts = async (hotelId) => {
    try {
      const response = await ProductService.index({
        hotel_id: hotelId,
        with: 'category,category.parent,domain'
      }, api);
      setHotelProducts(response);
    } catch (error) {

    }
  };

  const handleManageProduct = (hotel) => {
    setSelectedHotelId(hotel.id);
    fetchHotelProducts(hotel.id);
    setIsProductEditModalOpen(true);
    setIsProductListVisible(true);
  };

  const handleAddNewProduct = async () => {
    setProductFormData({
      id: null,
      name: "",
      description: "",
      duration: "",
      price: "",
      is_active: 1,
      hotel_id: selectedHotelId,
      parent_category_id: "",
      category_id: "",
      domain_id: "",
      subcategory_id: "",

    });
    setIsProductListVisible(false);
    const domainResponse = await DomainService.index({ hotel_id: selectedHotelId, with: "media,zones,hotel" }, api);
    setDomains(domainResponse);
  };

  const handleProductEdit = async (product) => {
    // Extract IDs from product relationships
    const domainId = product.domain?.id || product.domain_id || "";
    const categoryId = product.category?.parent?.id || product.parent_category_id || "";
    const subcategoryId = product.category?.id || product.category_id || "";

    setProductFormData({
      id: product.id,
      name: product.name,
      description: product.description,
      duration: product.duration,
      price: product.price,
      is_active: product.is_active ? 1 : 0,
      hotel_id: selectedHotelId,
      parent_category_id: categoryId,
      category_id: categoryId,
      domain_id: domainId,
      subcategory_id: subcategoryId,
    });

    // Load related data for dropdowns
    try {
      const domainResponse = await DomainService.index({ hotel_id: selectedHotelId, with: "media,zones,hotel" }, api);
      setDomains(domainResponse);

      if (domainId) {
        const topLevelCategories = await CategoryService.index({ domain_id: domainId, parent_id: null, status: 'ACTIVE' }, api);
        setCategories(topLevelCategories);
      }

      if (categoryId) {
        const subCategoriesResponse = await CategoryService.index({ parent_id: categoryId, status: 'ACTIVE' }, api);
        setSubCategories(subCategoriesResponse);
      }
    } catch (error) {
      console.error('Error loading related data:', error);
    }

    console.log("productFormData: ", productFormData);

    setIsProductListVisible(false);
  };

  const handleProductStatusToggle = async (product) => {
    try {
      await ProductService.update(product.id, { is_active: !product.is_active }, api);

      fetchHotelProducts(selectedHotelId);
    } catch (error) {

    }
  };

  const handleShowMap = async () => {
    if (!showMap) {
      await fetchCoordinates();
      setShowMap(true);
    } else {
      setShowMap(false);
    }
  };

  const handleClick = (event, index) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedIndex(index);
  };


  const handleClose = () => {
    setAnchorEl(null);
    setSelectedIndex(null);
  };

  const [filterMenuAnchor, setFilterMenuAnchor] = useState(null);
  const filterMenuOpen = Boolean(filterMenuAnchor);

  const handleFilterMenuClick = (event) => {
    setFilterMenuAnchor(event.currentTarget);
  };

  const handleFilterMenuClose = () => {
    setFilterMenuAnchor(null);
  };

  const handlePhoneChange = (value) => {
    setFormData({
      ...formData,
      phone: value,
    });
  };


  return (
    <>
      <MenuHeader />

      <div className="bloc-search bloc-search-mobile">
        <div className="container">
          <div className="desktop-hidden">
            <IconButton onClick={handleFilterMenuClick}>
              <img src='assets/images/filter.png' alt='actions' height={20} />
            </IconButton>
            <Menu anchorEl={filterMenuAnchor}
              open={filterMenuOpen}
              onClose={handleFilterMenuClose}
            >
              <MenuList
                style={{ padding: 0 }}
              >
                <MenuItem onClick={handleFilterMenuClose} disableRipple>
                  <ListItemIcon>
                    <img src='assets/images/filter.png' alt='actions' height={20} />

                  </ListItemIcon>
                  <ListItemText>Filters</ListItemText>
                </MenuItem>
                <Divider></Divider>
                <form onSubmit={handleFilterSubmit} className="search">
                  <div className="bloc-filtre">
                    <select
                      name="search_by"
                      value={filterData.search_by}
                      onChange={handleFilterChange}
                    >
                      <option value="name">{t('filters.search.by.name')}</option>
                      <option value="city">{t('filters.search.by.city')}</option>
                      <option value="contact_first_name">{t('filters.search.by.contactFirstName')}</option>
                      <option value="contact_last_name">{t('filters.search.by.contactLastName')}</option>
                    </select>
                    <select
                      name="operator"
                      value={filterData.operator}
                      onChange={handleFilterChange}
                    >
                      <option value="contains">{t('filters.search.operator.contains')}</option>
                      <option value="starts">{t('filters.search.operator.starts')}</option>
                      <option value="ends">{t('filters.search.operator.ends')}</option>
                      <option value="eq">{t('filters.search.operator.eq')}</option>
                      <option value="!eq">{t('filters.search.operator.neq')}</option>
                    </select>
                  </div>
                </form>
              </MenuList>
            </Menu>
          </div>
          <div className="mobile-hidden">
            <form onSubmit={handleFilterSubmit} className="search">
              <div className="text-search">
                <input
                  type="text"
                  name="search"
                  value={filterData.search}
                  onChange={handleFilterChange}
                  placeholder={t('filters.search.placeholder')}
                  className="form-text"
                />
                <input type="submit" className="form-submit" value={t('filters.search.button')} />
              </div>
              <div className="bloc-filtre">
                <select
                  name="search_by"
                  value={filterData.search_by}
                  onChange={handleFilterChange}
                >
                  <option value="name">{t('filters.search.by.name')}</option>
                  <option value="city">{t('filters.search.by.city')}</option>
                  <option value="contact_first_name">{t('filters.search.by.contactFirstName')}</option>
                  <option value="contact_last_name">{t('filters.search.by.contactLastName')}</option>
                </select>
                <select
                  name="operator"
                  value={filterData.operator}
                  onChange={handleFilterChange}
                >
                  <option value="contains">{t('filters.search.operator.contains')}</option>
                  <option value="starts">{t('filters.search.operator.starts')}</option>
                  <option value="ends">{t('filters.search.operator.ends')}</option>
                  <option value="eq">{t('filters.search.operator.eq')}</option>
                  <option value="!eq">{t('filters.search.operator.neq')}</option>
                </select>
              </div>
            </form>
          </div>
          <a onClick={openModal} className="btn-add-client" style={{ lineHeight: '40px' }}>
            {t('actions.add')}
          </a>
        </div>
      </div>

      <div className="tableau-list view-mobile view-rows">
        <div className="container">
          {hotels?.length > 0 ? (
            hotels.map((hotel, index) => (
              <div className="list-items" key={hotel.id}>
                <div className="img-items">
                  <img
                    src={`${hotel.media[0]?.original_url}`}
                    alt="Client image"
                    style={{ width: "50px", height: "50px" }}
                  />
                </div>
                <div className="infos-items">
                  <div>Hotel name : {hotel.name}</div>
                  <div>
                    Hotel Address : {addressFormat(hotel.address)}
                  </div>
                  <div>Contact name : {hotel.contact_first_name + " " + hotel.contact_last_name}</div>
                  <div>Phone : {hotel.phone}</div>
                  <div>
                    <a href="#" onClick={() => openModalManage(hotel)} className="see-more edit">
                      See more
                    </a>
                  </div>
                </div>
                <div className="menu-edit">
                  <IconButton onClick={(event) => handleClick(event, index)}>
                    <MoreVertIcon />
                  </IconButton>

                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl) && selectedIndex === index}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                  >
                    <MenuList style={{ minWidth: 150 }}>
                      <MenuItem onClick={() => { handleClose(); openFicheModal(hotel); }}>
                        <ListItemIcon>
                          <EditIcon style={{ color: "#1976d2" }} />
                        </ListItemIcon>
                        <ListItemText>Show Hotel Questionnaire</ListItemText>
                      </MenuItem>
                      {/* Edit Hotel */}
                      <MenuItem onClick={() => { handleClose(); openModal(hotel); }}>
                        <ListItemIcon>
                          <EditIcon style={{ color: "#1976d2" }} />
                        </ListItemIcon>
                        <ListItemText>Edit Hotel</ListItemText>
                      </MenuItem>

                      {/* Manage Addresses */}
                      <MenuItem onClick={() => { handleClose(); openManageModal("addresses", hotel); }}>
                        <ListItemIcon>
                          <LocationOnIcon style={{ color: "#1976d2" }} />
                        </ListItemIcon>
                        <ListItemText>Manage Addresses</ListItemText>
                      </MenuItem>

                      {/* Manage Products */}
                      <MenuItem onClick={() => { handleClose(); handleManageProduct(hotel); }}>
                        <ListItemIcon>
                          <Inventory2Icon style={{ color: "#1976d2" }} />
                        </ListItemIcon>
                        <ListItemText>Manage Product</ListItemText>
                      </MenuItem>

                      {/* Delete */}
                      <MenuItem style={{ color: 'red' }} onClick={() => { handleClose(); handleDelete(hotel.id); }}>
                        <ListItemIcon>
                          <DeleteIcon style={{ color: "red" }} />
                        </ListItemIcon>
                        <ListItemText>Delete</ListItemText>
                      </MenuItem>
                    </MenuList>
                  </Menu>

                </div>

              </div>
            ))
          ) : (
            <div>
              <div colSpan="6">No hotels found.</div>
            </div>
          )}
        </div>
      </div>

      <div className="tableau-list  view-desktop">
        <div className="container">
          <table>
            <thead className="no-background">
              <tr>
                <th className="sort-header active" id="name" onClick={handleSelectedSort}>{t('table.headers.name')}</th>
                <th>{t('table.headers.image')}</th>
                <th className="sort-header" id="address" onClick={handleSelectedSort}>{t('table.headers.address')}</th>
                <th className="sort-header" id="contact_first_name" onClick={handleSelectedSort}>{t('table.headers.contactName')}</th>
                <th className="sort-header" id="phone" onClick={handleSelectedSort}>{t('table.headers.phone')}</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {hotels?.length > 0 ? (
                hotels.map((hotel, index) => (
                  <tr key={hotel.id}>
                    <td>{hotel.name}</td>
                    <td>
                      <img
                        src={`${hotel.media[0]?.original_url}`}
                        alt="Client image"
                        style={{ width: "50px", height: "50px" }}
                      />
                    </td>
                    <td>
                      {addressFormat(hotel.address)}
                    </td>
                    <td>{hotel.contact_first_name + " " + hotel.contact_last_name}</td>
                    <td>{hotel.phone}</td>
                    <td>
                      <a href="#" onClick={() => openModalManage(hotel)} className="see-more edit">
                        {t('actions.seeMore')}
                      </a>
                    </td>
                    <td>
                      <IconButton onClick={(event) => handleClick(event, index)}>
                        <MoreVertIcon />
                      </IconButton>

                      <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl) && selectedIndex === index}
                        onClose={handleClose}
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                      >
                        <MenuList style={{ minWidth: 150 }}>
                          <MenuItem onClick={() => { handleClose(); openFicheModal(hotel); }}>
                            <ListItemIcon>
                              <EditIcon style={{ color: "#1976d2" }} />
                            </ListItemIcon>
                            <ListItemText>{t('actions.showQuestionnaire')}</ListItemText>
                          </MenuItem>
                          {/* Edit Hotel */}
                          <MenuItem onClick={() => { handleClose(); openModal(hotel); }}>
                            <ListItemIcon>
                              <EditIcon style={{ color: "#1976d2" }} />
                            </ListItemIcon>
                            <ListItemText>{t('actions.edit')} {t('table.headers.hotel')}</ListItemText>
                          </MenuItem>

                          {/* Manage Addresses */}
                          <MenuItem onClick={() => { handleClose(); openManageModal("addresses", hotel); }}>
                            <ListItemIcon>
                              <LocationOnIcon style={{ color: "#1976d2" }} />
                            </ListItemIcon>
                            <ListItemText>{t('actions.manageAddresses')}</ListItemText>
                          </MenuItem>

                          {/* Manage Products */}
                          <MenuItem onClick={() => { handleClose(); handleManageProduct(hotel); }}>
                            <ListItemIcon>
                              <Inventory2Icon style={{ color: "#1976d2" }} />
                            </ListItemIcon>
                            <ListItemText>{t('actions.manageProduct')}</ListItemText>
                          </MenuItem>

                          {/* Delete */}
                          <MenuItem style={{ color: 'red' }} onClick={() => { handleClose(); handleDelete(hotel.id); }}>
                            <ListItemIcon>
                              <DeleteIcon style={{ color: "red" }} />
                            </ListItemIcon>
                            <ListItemText>{t('actions.delete')}</ListItemText>
                          </MenuItem>
                        </MenuList>
                      </Menu>

                    </td>

                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">{t('table.noData.hotels')}</td>
                </tr>
              )}
            </tbody>
            <tfoot >
              <tr>
                <td colSpan={8}>
                  <div className="paginator">
                    <select value={perPage} onChange={handlePerPageChange} className="per-page">
                      <option value={1}>1</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={250}>250</option>
                      <option value={500}>500</option>
                      <option value={1000}>1000</option>
                    </select>
                    <div className="total">{t('table.pagination.total', { count: total })}</div>
                    <div className="pagination">
                      <button type="button" disabled={currentPage === 1} onClick={handleFirstPage}>{'<<'}</button>
                      <button type="button" disabled={currentPage === 1} onClick={handlePrevPage}>{'<'}</button>
                      <span>{currentPage} / {lastPage}</span>
                      <button type="button" disabled={currentPage === lastPage} onClick={handleNextPage}>{'>'}</button>
                      <button type="button" disabled={currentPage === lastPage} onClick={handleLastPage}>{'>>'}</button>
                    </div>
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel={t('modals.titles.addHotel')}
      >
        <button className="close-button" onClick={closeModal}>
          <span className="close-icon">✖</span>
        </button>

        <h2>{formData.id ? t('form.buttons.update') : t('form.buttons.create')}</h2>
        <div className="form-inscription">
          <form onSubmit={handleSubmit}>
            <div className="form-text">
              <label>{t('form.labels.hotelName')} *</label>
              <input type="text" name="name" value={formData.name} onChange={handleChange} required />
            </div>
            <div className="flex-row gap-10">
              <div className="form-text">
                <label htmlFor="street">{t('form.labels.selectAddress')}</label>
                <Autocomplete
                  apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                  onPlaceSelected={handlePlaceSelect}
                  options={{
                    types: ["address"],
                    componentRestrictions: { country: "CH" },
                  }}
                  style={{
                    width: "100%",
                    padding: "0 15px",
                    height: "60px",
                    border: "0",
                    borderRadius: "20px",
                    boxShadow: "0px 8px 50px 0px rgba(0, 0, 0, 0.06)",
                  }}
                  defaultValue={autoCompleteValue}
                />
              </div>

              {isZipCodeVisible && (
                <div className="form-group">
                  <label>{t('form.labels.zipCode')} *</label>
                  <input
                    type="text"
                    value={formData.zip_code}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        zip_code: e.target.value,
                      }))
                    }
                    required
                  />
                </div>
              )}

              <div className="form-group icon-top-margin">
                {formData.zip_code && (
                  <img
                    src="assets/images/map-icon.svg"
                    alt="Map Icon"
                    className="clickable"
                    onClick={handleShowMap}
                  />
                )}
              </div>
            </div>

            <div>
              {formData.latitude && showMap && (<Map
                coordinates={[coordinates]}
                mode="edit"
                containerStyle={{ width: '100%', height: '400px' }}
                mapOptions={{
                  disableDefaultUI: true,
                  zoomControl: true,
                  mapTypeControl: false,
                  fullscreenControl: true,
                  streetViewControl: false,
                }}
                onCoordinateChange={handleCoordinateChange}
              />)}
            </div>

            <div className="form-text">
              <label>{t('form.labels.contactFirstName')} *</label>
              <input type="text" name="contact_first_name" value={formData.contact_first_name} onChange={handleChange} required />
            </div>
            <div className="form-text">
              <label>{t('form.labels.contactLastName')} *</label>
              <input type="text" name="contact_last_name" value={formData.contact_last_name} onChange={handleChange} required />
            </div>
            <div className="form-text">
              <label>{t('form.labels.phone')}</label>
              <PhoneInput
                name="phone"
                value={formData.phone}
                defaultCountry="ch"
                forceDialCode={true}
                disableCountryGuess={false}
                onChange={handlePhoneChange}
                className="phone-input"
                inputMode="tel"
                maxLength={15}
              />
            </div>
            <div className="form-text">
              <label>{t('form.labels.email')}</label>
              <input type="text" name="email" value={formData.email} onChange={handleChange} />
            </div>
            <div className="form-text topMargArea">
              <label>{t('form.labels.flyproInstructions')}</label>
              <textarea
                className="formTextArea"
                value={formData.flypro_instructions}
                name="flypro_instructions"
                placeholder={t('form.placeholders.flyproInstructions')}
                onChange={handleChange}
              />
            </div>
            <div className="capability-input topMargArea">
              <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
                <Typography>{t('form.labels.duoCapability')}</Typography>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Typography>{t('form.toggles.no')}</Typography>
                  <Switch
                    checked={formData.duo_capability}
                    onChange={handleSwitchChange}
                    inputProps={{ 'aria-label': 'DUO Capability' }}
                  />
                  <Typography>{t('form.toggles.yes')}</Typography>
                </Stack>
              </Stack>
            </div>
            <div className="capability-input topMargArea">
              <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
                <Typography>{t('form.labels.onlyInternal')}</Typography>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Typography>{t('form.toggles.no')}</Typography>
                  <Switch
                    checked={formData.is_only_internal}
                    onChange={handleSwitchInternalChange}
                    inputProps={{ 'aria-label': 'Only internal client' }}
                  />
                  <Typography>{t('form.toggles.yes')}</Typography>
                </Stack>
              </Stack>
            </div>
            <label className="fileLabel" htmlFor="file">
              {t('form.labels.image.upload')} *
            </label>
            <div className="fileField">
              <label htmlFor="file">
                <img className="imgFile" src={imageFile || ""} alt="File upload" />
                {fileName ? (
                  <div>{t('form.labels.image.uploaded', { name: fileName })}</div>
                ) : (
                  <>
                    <div className="selectFileTo">{t('form.labels.image.select')}</div>
                    <div className="orDragAnd">
                      {t('form.labels.image.dragDrop')}
                    </div>
                  </>
                )}
              </label>
              <input
                type="file"
                id="file"
                name="file"
                accept="image/*"
                onChange={handleChange}
                ref={fileInputRef}
                style={{ display: "none" }}
              />
            </div>
            <button type="submit" className="btn-submit">{formData.id ? t('form.buttons.update') : t('form.buttons.create')}</button>
          </form>
        </div>
      </Modal>

      <Modal
        isOpen={modalIsOpenManage && selectedHotel !== null}
        onRequestClose={closeModalManage}
        style={customStyles}
        contentLabel={t('modals.titles.manageHotel')}
      >
        <div className="form-inscription mrgBottom">
          <h2>{selectedHotel?.name}</h2>
          <form>
            <div className="input-hotel-container">
              <label className="input-hotel-label">{t('form.labels.hotelName')}</label>
              <input type="text" name="address" value={addressFormat(selectedHotel?.address)} readOnly />
            </div>
            <div className="input-hotel-container">
              <label className="input-hotel-label">{t('table.headers.contactName')}:</label>
              <input type="text" name="contact_first_name" value={`${selectedHotel?.contact_first_name || ''} ${selectedHotel?.contact_last_name || ''}`.trim()} readOnly />
            </div>
            <div className="input-hotel-container">
              <label className="input-hotel-label">{t('form.labels.phone')}*</label>
              <input type="text" name="phone" value={selectedHotel?.phone || ''} readOnly />
            </div>
            <div className="input-hotel-container">
              <label className="input-hotel-label">{t('form.labels.email')}</label>
              <input type="text" name="email" value={selectedHotel?.email || ''} readOnly />
            </div>
            <div className="account-hotel-management">
              <div className="input-hotel-container">
                <label htmlFor="accountManagement" className="input-hotel-label">{t('modals.sections.accountManagement')}</label>
                <input
                  type="text"
                  id="accountManagement"
                  name="accountManagement"
                  readOnly
                  value=" "
                />
                {selectedHotel?.account ? (
                  <div className="account-info-container">
                    <span className="hotel-account">
                      {selectedHotel.account.extra.full_name}
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          handleEditAccount(selectedHotel.account);
                        }}
                        className="edit-account-button"
                      >
                        {t('actions.edit')}
                      </button>
                    </span>
                  </div>
                ) : (
                  <a href="#" onClick={(e) => handleCreateAccountClick(e, selectedHotel.id)} className="create-hotel-account">
                    {t('actions.createAccount')}
                  </a>
                )}
              </div>
            </div>
            <div className="capability-input topMargArea">
              <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between" sx={{ marginRight: '220px' }}>
                <Typography>{t('form.labels.duoCapability')}</Typography>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Typography>{t('form.toggles.no')}</Typography>
                  <Switch
                    checked={selectedHotel?.duo_capability}
                    onChange={handleSwitchChange}
                    inputProps={{ 'aria-label': 'DUO Capability' }}
                  />
                  <Typography>{t('form.toggles.yes')}</Typography>
                </Stack>
              </Stack>
            </div>
            <div className="capability-input topMargArea">
              <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between" sx={{ marginRight: '220px' }}>
                <Typography>{t('form.labels.onlyInternal')}</Typography>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Typography>{t('form.toggles.no')}</Typography>
                  <Switch
                    checked={selectedHotel?.is_only_internal}
                    onChange={handleSwitchInternalChange}
                    inputProps={{ 'aria-label': 'Only internal client' }}
                  />
                  <Typography>{t('form.toggles.yes')}</Typography>
                </Stack>
              </Stack>
            </div>
            <div className="capability-input topMargArea">
              <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
                <Typography>{t('form.labels.filterDate')}</Typography>
                <TextField
                  label={t('form.labels.startDate')}
                  variant="outlined"
                  type="date"
                  name="start_date"
                  value={dateRange.start_date}
                  onChange={(e) =>
                    setDateRange({ ...dateRange, start_date: e.target.value })
                  }
                  InputLabelProps={{ shrink: true }}
                  size="small"
                />

                <TextField
                  label={t('form.labels.endDate')}
                  variant="outlined"
                  type="date"
                  name="end_date"
                  value={dateRange.end_date}
                  onChange={(e) =>
                    setDateRange({ ...dateRange, end_date: e.target.value })
                  }
                  InputLabelProps={{ shrink: true }}
                  size="small"
                />
              </Stack>
            </div>          
            <div className="form-text booking-zone topMargArea">
              <span className="list-all-bookings">{t('modals.sections.hotelBookings')}</span>
              <span className="list-excel-all-bookings">{t('modals.sections.extractExcel')}</span>
              <table className="table-bookings">
                <thead>
                  <tr>
                    <th>{t('table.headers.bookingId')}</th>
                    <th>{t('table.headers.client')}</th>
                    <th>{t('table.headers.date')}</th>
                    <th>{t('table.headers.treatmentType')}</th>
                    <th>{t('table.headers.status')}</th>
                  </tr>
                </thead>
                <tbody>
                  {translatedBookings.length > 0 ? (
                    translatedBookings.map((booking) => (
                      <tr key={booking.id}>
                        <td>{booking.id}</td>
                        <td>{booking.client?.extra?.full_name}</td>
                        <td>{booking.start_before ? new Date(booking.start_before).toLocaleDateString(i18n.language === 'fr' ? 'fr-FR' : 'en-US').split('T')[0] : 'N/A'}</td>
                        <td style={{ whiteSpace: 'pre-line' }}>{booking.products?.map(p => `- ${p?.category?.title} ${p?.duration} min`).join('\n')}</td>
                        <td>{t(booking.status)}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5">{t('table.noBookings')}</td>
                    </tr>
                  )}
                </tbody>
              </table>
              <div className="list-button" style={{ marginTop: 25 }}>
                <div className="paginator" style={{ display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div className="pagination">{allBookingsTotal > 0 ? t('table.pagination.total', { count: allBookingsTotal }) : ''}
                    <button type="button" disabled={allBookingsPage === 1} onClick={() => setAllBookingsPage(1)}>{'<<'}</button>
                    <button type="button" disabled={allBookingsPage === 1} onClick={() => setAllBookingsPage(allBookingsPage - 1)}>{'<'}</button>
                    <span>{allBookingsPage}</span>
                    <button type="button" disabled={allBookingsPage * bookingsPerPage >= allBookingsTotal} onClick={() => setAllBookingsPage(allBookingsPage + 1)}>{'>'}</button>
                  </div>
                </div>
                <div className="extract-button" onClick={() => handleExportClientBookings(selectedHotel.id, selectedHotel.account_id)} style={{ overflow: 'visible', margin: 'auto' }}>
                  {t('actions.extractBooking')}
                </div>
              </div>
            </div>
            <div className="form-text booking-zone extractMrg">
              <span className="list-all-bookings">{t('modals.sections.directBookings')}</span>
              <span className="list-excel-all-bookings">{t('modals.sections.extractExcel')}</span>
              <table className="table-bookings">
                <thead>
                  <tr>
                    <th>{t('table.headers.bookingId')}</th>
                    <th>{t('table.headers.manager')}</th>
                    <th>{t('table.headers.date')}</th>
                    <th>{t('table.headers.treatmentType')}</th>
                    <th>{t('table.headers.status')}</th>
                  </tr>
                </thead>
                <tbody>
                  {translatedDirectBookings.length > 0 ? (
                    translatedDirectBookings.map((booking) => (
                      <tr key={booking.id}>
                        <td>{booking.id}</td>
                        <td>{booking.client?.extra?.full_name}</td>
                        <td>{booking.start_before ? new Date(booking.start_before).toLocaleDateString(i18n.language === 'fr' ? 'fr-FR' : 'en-US').split('T')[0] : 'N/A'}</td>
                        <td style={{ whiteSpace: 'pre-line' }}>{booking.products?.map(p => `- ${p?.category?.title} ${p?.duration} min`).join('\n')}</td>
                        <td>{t(booking.status)}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5">{t('table.noBookings')}</td>
                    </tr>
                  )}
                </tbody>
              </table>
              <div className="list-button" style={{ marginTop: 25 }}>
                <div className="paginator" style={{ display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div className="pagination">{directBookingsTotal > 0 ? t('table.pagination.total', { count: directBookingsTotal }) : ''}
                    <button type="button" disabled={directBookingsPage === 1} onClick={() => setDirectBookingsPage(1)}>{'<<'}</button>
                    <button type="button" disabled={directBookingsPage === 1} onClick={() => setDirectBookingsPage(directBookingsPage - 1)}>{'<'}</button>
                    <span>{directBookingsPage}</span>
                    <button type="button" disabled={directBookingsPage * bookingsPerPage >= directBookingsTotal} onClick={() => setDirectBookingsPage(directBookingsPage + 1)}>{'>'}</button>
                  </div>
                </div>
                <div className="extract-button" onClick={() => handleExportMergedDirectHotelBookings(selectedHotel.id, selectedHotel.account_id)} style={{ overflow: 'visible', margin: 'auto' }}>
                  {t('actions.extractBooking')}
                </div>
              </div>
            </div>
          </form>
        </div>
      </Modal>

      <Modal
        isOpen={isAccountModalOpen}
        onRequestClose={handleModalClose}
        style={customStyles}
        contentLabel={accountFormData.id ? t('modals.titles.editAccount') : t('modals.titles.createAccount')}
      >
        <button className="close-button" onClick={handleModalClose}>
          <span className="close-icon">✖</span>
        </button>
        <h2>{accountFormData.id ? t('modals.titles.editAccount') : t('modals.titles.createAccount')}</h2>
        <form onSubmit={(e) => handleAccountFormSubmit(e, selectedHotel.id)}>
          <div className="form-inscription mrgBottom">
            <div className="form-text">
              <label>{t('form.labels.email')} *</label>
              <input
                type="email"
                name="email"
                value={accountFormData.email}
                onChange={handleAccountFormChange}
                required
              />
            </div>
            <div className="form-text">
              <label>{t('form.labels.firstname')} *</label>
              <input
                type="text"
                name="firstname"
                value={accountFormData.firstname}
                onChange={handleAccountFormChange}
                required
              />
            </div>
            <div className="form-text">
              <label>{t('form.labels.lastname')} *</label>
              <input
                type="text"
                name="lastname"
                value={accountFormData.lastname}
                onChange={handleAccountFormChange}
                required
              />
            </div>
            <div className="form-text">
              <label>{t('form.labels.phone')}</label>
              <PhoneInput
                name="phone"
                value={accountFormData.phone}
                defaultCountry="ch"
                forceDialCode={true}
                disableCountryGuess={false}
                onChange={handleAccPhoneChange}
                className="phone-input"
                inputMode="tel"
                maxLength={15}
              />
            </div>
            <button type="submit" className="btn-submit">
              {accountFormData.id ? t('actions.updateAccount') : t('actions.createAccount')}
            </button>
          </div>
        </form>
      </Modal>

      <Modal
        isOpen={modalIsOpenAddressManage}
        onAfterOpen={afterOpenManageModal}
        onRequestClose={closeModalAddressManage}
        style={customStyles}
        ariaHideApp={false}
        contentLabel="Manage Modal"
      >
        <div className="bloc-manage">
          {modalType === "addresses" && (
            <div className="manage-managers-modal">
              <h2>{t('modals.titles.manageAddresses')} {selectedRow?.name}</h2>
              {/* Assigned Addresses Section */}
              <div className="currently-managed">
                <div className="assigned-addresses">
                  <h3>{t('modals.sections.assignedAddresses')}</h3>
                  <div className="tableau-list no-scroll no-padding-bottom">
                    <div className="container">
                      <table>
                        {selectedRow?.addresses
                          .filter((address) => {
                            return address.hotel_id === selectedRow.id;
                          })
                          .map((address) => (
                            <thead key={address.id} className="no-background">
                              <tr>
                                <th>{address.street_number} {address.street}, {address.zip_code} {address.city}</th>
                                <th>
                                  <button
                                    className="form-submit"
                                    onClick={() => handleRemoveAddress(address)}
                                  >
                                    {t('actions.remove')}
                                  </button>
                                </th>
                              </tr>
                            </thead>
                          ))
                        }
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              {/* Add Addresses Section */}
              <div className="form-text topMargArea">
                <h3>{t('modals.sections.addNewAddress')}</h3>
                <form onSubmit={handleAddAddress}>
                  <div className="form-group">
                    <label htmlFor="street">{t('form.labels.selectAddress')}</label>
                    <Autocomplete
                      apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                      onPlaceSelected={handlePlaceSelect}
                      options={{
                        types: ['address'],
                        componentRestrictions: { country: 'CH' },
                      }}
                      style={{ width: '100%', padding: '0 15px', height: '60px', border: '0', borderRadius: '20px', boxShadow: '0px 8px 50px 0px rgba(0, 0, 0, 0.06)' }}
                    />
                  </div>

                  {isZipCodeVisible && (
                    <div className="form-group">
                      <label>{t('form.labels.zipCode')} *</label>
                      <input
                        type="text"
                        value={newAddress.zip_code}
                        onChange={(e) => setNewAddress(prev => ({ ...prev, zip_code: e.target.value }))}
                        required
                      />
                    </div>
                  )}

                  <button type="submit" className="btn-submit">
                    {t('hotel:form.buttons.addAddress')}
                  </button>
                </form>
              </div>
            </div>
          )}
        </div>
      </Modal>

      <Modal
        isOpen={isProductEditModalOpen}
        onRequestClose={() => setIsProductEditModalOpen(false)}
        style={customStyles}
        contentLabel="Manage Product"
      >
        <button className="close-button" onClick={() => setIsProductEditModalOpen(false)}>
          <span className="close-icon">✖</span>
        </button>

        <h2>{t('modals.titles.manageProduct')}</h2>

        {isProductListVisible ? (
          <>
            <div className="tableau-list no-scroll">
              <div className="container">
                <table>
                  <thead className="no-background">
                    <tr>
                      <th>{t('table.headers.productName')}</th>
                      <th>{t('table.headers.duration')}</th>
                      <th>{t('table.headers.price')}</th>
                      <th>{t('table.headers.status')}</th>
                      <th>{t('table.headers.enableDisable')}</th>
                      <th>{t('table.headers.actions')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {translatedHotelProducts?.map((product) => (
                      <tr key={product.id} className={
                        !product?.is_active
                          ? "disabled-item"
                          : ""
                      }>
                        <td>{product.name}</td>
                        <td>{product.duration}</td>
                        <td>{product.price}</td>
                        <td className={product.is_active ? "active" : "disabled"}>
                          {product.is_active ? t('table.headers.statusActive') : t('table.headers.statusDisabled')}
                        </td>
                        <td>
                          <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                            <AntSwitch
                              checked={!!product.is_active}
                              onChange={() => handleProductStatusToggle(product)}
                              inputProps={{ "aria-label": "toggle product status" }}
                            />
                          </Stack>
                        </td>
                        <td>
                          <button className="form-submit" onClick={() => handleProductEdit(product)}>{t('actions.edit')}</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="table-header">
              <h2></h2>
              <button onClick={handleAddNewProduct} className="btn-add-product">
                {t('actions.addProduct')}
              </button>
            </div>
          </>
        ) : (
          <div className="form-inscription">
            <form onSubmit={handleProductSubmit}>
              <div className="form-text">
                <label>domain *</label>
                <select
                  required
                  name="domain_id"
                  onChange={handleProductChange}
                  value={productFormData.domain_id}
                >
                  <option value="">Select a domain</option>
                  {translatedDomains.length > 0 ? (
                    translatedDomains.map((row) => (
                      <option key={row.id} value={row.id}>{row.title}</option>
                    ))
                  ) : (
                    <option value="" disabled>No domains available</option>
                  )}
                </select>
              </div>
              <div className="form-text">
                <label>category *</label>
                <select
                  required
                  name="category_id"
                  onChange={handleProductChange}
                  value={productFormData.category_id}
                >
                  <option value="">Select a category</option>
                  {translatedCategories.length > 0 ? (
                    translatedCategories.map((row) => (
                      <option key={row.id} value={row.id}>{row.title}</option>
                    ))
                  ) : (
                    <option value="" disabled>No categories available</option>
                  )}
                </select>
              </div>
              <div className="form-text">
                <label>Subcategory</label>
                <select
                  name="subcategory_id"
                  onChange={handleProductChange}
                  value={productFormData.subcategory_id}
                >
                  <option value="">Select a subcategory</option>
                  {translatedSubCategories.length > 0 ? (
                    translatedSubCategories.map((row) => (
                      <option key={row.id} value={row.id}>{row.title}</option>
                    ))
                  ) : (
                    <option value="" disabled>No subcategories available</option>
                  )}
                </select>
              </div>
              <div className="form-text">
                <label>{t('form.labels.productName')} *</label>
                <input
                  required
                  type="text"
                  name="name"
                  value={productFormData.name}
                  onChange={handleProductChange}
                />
              </div>

              <div className="form-text">
                <label>{t('form.labels.description')} *</label>
                <textarea
                  required
                  className="formTextArea"
                  name="description"
                  value={productFormData.description}
                  onChange={handleProductChange}
                />
              </div>

              <div className="form-text">
                <label>{t('form.labels.duration')} *</label>
                <input
                  required
                  type="number"
                  name="duration"
                  value={productFormData.duration}
                  onChange={handleProductChange}
                  min="0"
                  max="240"
                />
              </div>

              <div className="form-text">
                <label>{t('form.labels.price')} *</label>
                <input
                  required
                  type="number"
                  name="price"
                  value={productFormData.price}
                  onChange={handleProductChange}
                  min="0"
                  max="9999"
                />
              </div>

              <label className="fileLabel" htmlFor="file">
                {t('form.labels.imageUpload')}*
              </label>
              <div className="fileField">
                <label htmlFor="file">
                  <img className="imgFile" src={imageFile} alt="File upload" />
                  {fileName ? (
                    <div>{t('form.labels.uploadedFile')}: {fileName}</div>
                  ) : (
                    <>
                      <div className="selectFileTo">{t('form.labels.selectFile')}</div>
                      <div className="orDragAnd">
                        {t('form.labels.dragAndDrop')}
                      </div>
                    </>
                  )}
                </label>
                <input
                  type="file"
                  id="file"
                  name="file"
                  accept="image/*"
                  onChange={handleProductChange}
                  ref={fileInputRef}
                  style={{ display: "none" }}
                />
              </div>

              <div className="capability-input">
                <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
                  <Typography>{t('form.labels.status')}</Typography>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography>{t('form.toggles.disabled')}</Typography>
                    <Switch
                      checked={!!productFormData.is_active}
                      onChange={handleFormSwitchChange}
                      inputProps={{ "aria-label": "status" }}
                    />
                    <Typography>{t('form.toggles.active')}</Typography>
                  </Stack>
                </Stack>
              </div>

              <div className="actions">
                <button type="button" onClick={() => setIsProductListVisible(true)} className="btn-submit">
                  {t('actions.cancel')}
                </button>
                <button type="submit" className="btn-submit">
                  {t('actions.save')}
                </button>
              </div>
            </form>
          </div>
        )}
      </Modal>
      <Modal
        isOpen={detailsModalIsOpenFiche}
        onRequestClose={closeFichesModal}
        style={customStyles}
      >
        <button className="close-button" onClick={closeFichesModal}>
          <span className="close-icon">✖</span>
        </button>
        {selectedHotel && (
          <div className="form-inscription mrgBottom">
            <h2>{t('modals.titles.questionnaire')} {selectedHotel.name}</h2><br />
            <form onSubmit={handleSubmitFiche}>
              <div className="input-hotel-container">
                <label className="input-hotel-label">{t('questionnaire.parking')}</label>
                <input type="text" name="parking" value={ficheFormData.parking} onChange={handleChangeFiche} />
              </div>
              <div className="input-hotel-container">
                <label className="input-hotel-label">{t('questionnaire.dress')}</label>
                <input type="text" name="tenue_vestimentaire" value={ficheFormData.tenue_vestimentaire} onChange={handleChangeFiche} />
              </div>
              <div className="input-hotel-container">
                <label className="input-hotel-label">{t('questionnaire.whereToGo')}</label>
                <input type="text" name="ou_se_diriger" value={ficheFormData.ou_se_diriger} onChange={handleChangeFiche} />
              </div>
              <div className="input-hotel-container">
                <label className="input-hotel-label">{t('questionnaire.howToSettle')}</label>
                <input type="text" name="comment_et_ou_sinstaller" value={ficheFormData.comment_et_ou_sinstaller} onChange={handleChangeFiche} />
              </div>
              <div className="input-hotel-container">
                <label className="input-hotel-label">{t('questionnaire.materialToBring')}</label>
                <input type="text" name="materiel_a_prendre" value={ficheFormData.materiel_a_prendre} onChange={handleChangeFiche} />
              </div>
              <div className="input-hotel-container">
                <label className="input-hotel-label">{t('questionnaire.materialOnSite')}</label>
                <input type="text" name="materiel_sur_place" value={ficheFormData.materiel_sur_place} onChange={handleChangeFiche} />
              </div>
              <div className="input-hotel-container">
                <label className="input-hotel-label">{t('questionnaire.services')}</label>
                <input type="text" name="prestations_que_lon_peut_fournir" value={ficheFormData.prestations_que_lon_peut_fournir} onChange={handleChangeFiche} />
              </div>
              <div className="input-hotel-container">
                <label className="input-hotel-label">{t('questionnaire.additionalInfo')}</label>
                <input type="text" name="infos_complementaires" value={ficheFormData.infos_complementaires} onChange={handleChangeFiche} />
              </div>
              <button type="submit" className="btn-submit">
                {ficheFormData.id ? t('form.buttons.update') : t('form.buttons.create')}
              </button>
            </form>
          </div>
        )}
      </Modal>

    </>
  );
};

export default Hotels;
